module.exports = __webpack_public_path__ + "img/61_3.409cc15a.png";